import { window } from "global";
import { useEffect } from "react";
import { MediaQuery } from "@outplayed/responsive";
import { TierListHeader } from "../../TierListHeader";
import { TierListPageNav } from "../../TierListPageNav";
import { TierListFilterManager } from "../../TierListFilterManager";
import { ObjectivesTierListTable } from "./ObjectivesTierListTable";
import { TierListTablePlaceholder } from "../../common/TierListTablePlaceholder";
import { TierListTableError } from "../../common/TierListTableError";

import { selectObjectivesData } from "@ugg/shared/api/data-parser/tier-lists/objectives-tier-list";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useObjectivesTierList } from "@ugg/shared/api/requests/tier-lists/objectives";
import { TIER_LIST_PAGES } from "@ugg/shared/pages/tier-list-pages";

type BannerProp = {
  bannerSlot?: JSX.Element | null;
};

export const ObjectivesTierListContainer = ({ bannerSlot }: BannerProp) => {
  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const { data, loading, error } = useObjectivesTierList({ params: queryParams, ssr: true });

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  const validatedParams = validateQueryParams(TIER_LIST_PAGES.COMBAT_TIER_LIST, queryParams, true);
  const filters = { ...validatedParams };
  const { objectives, last_updated, total_matches } = selectObjectivesData(data, filters);

  let table = null;
  if (!window) {
    table = null;
  } else if (loading) {
    table = <TierListTablePlaceholder />;
  } else if (error) {
    table = <TierListTableError />;
  } else {
    table = <ObjectivesTierListTable filters={filters} data={objectives || []} />;
  }

  return (
    <div>
      <TierListHeader
        className="mb-[24px]"
        totalMatches={total_matches}
        lastUpdated={last_updated}
        loading={loading}
        includeMeta
      />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div>
          <TierListPageNav />
        </div>
      </MediaQuery>
      {bannerSlot ?? null}
      <TierListFilterManager className="my-[24px]" />
      {table}
    </div>
  );
};
